import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import GraphLoader from 'app/domains/common/Loaders/GraphLoader'
import MobileGraphLoader from 'app/domains/common/Loaders/MobileGraphLoader'
import ChartBody from './ChartBody'
import TimeLineDots from './TimeLineDots'
import ChartTitle from './ChartTitle'
import ChartSlider from './ChartSlider'

import './styles.scss'

const bc = 'chart'

const Chart = ({ t, isMobile, pending, isSingle, isShowFeatureDot }) => (
  <div>
    <ChartTitle />

    {pending ? (
      !isMobile ? (
        <GraphLoader />
      ) : (
        <MobileGraphLoader />
      )
    ) : (
      <Fragment>
        {!isMobile && !isShowFeatureDot && <div className={`${bc}__text-y-axis`}>{t('Activities Completed')}</div>}
        <ChartBody isMobile={isMobile} />
        <TimeLineDots isMobile={isMobile} />
      </Fragment>
    )}
    {!isSingle && <ChartSlider />}
  </div>
)

Chart.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  isSingle: PropTypes.bool.isRequired,
  isShowFeatureDot: PropTypes.bool.isRequired,
}

export default withTranslation('user')(Chart)
